import React, { useEffect, useRef, useState } from "react";
import arrowDown from '../assets/arrowDown.svg'
import { AiOutlineSearch } from "react-icons/ai";
import categoryIcon from '../assets/category.svg'


const CategorySelector = ({ page, searchError, setSearchError, categoryData, handleCategorySelect, device, placeholder }) => {
  const [inputValue, setInputValue] = useState("");
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const handleOpen = () => {
    setSearchError('')
    setOpen(!open)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`relative w-full cursor-pointer ${device != "small" && searchError === "Category or Country is Required" ? "  border-2 border-[#EB0728] text-[#EB0728]" : ""}`} ref={dropdownRef}>
      <div
        onClick={() => handleOpen()}
        className={` w-full ${device === "small" ? ` ${searchError === "Category or Country is Required" || searchError === "Invalid Search" ? "border-2 border-[#EB0728] text-[#EB0728] md:text-[#EB0728] bg-white" : page === 'dashboard' ? "bg-white" : "bg-white  border border-ravgray "}  md:border-none rounded-[80px] w-full   ` : ""} py-[14px] px-[21px] font-medium text-base lg:text-sm  w-[200px]  h-[45px] xl:h-[50px] flex items-center justify-between text-center ${!selected && "text-[#707070]"
          }`}
      >
        {selected
          ? selected?.length > 15
            ? selected?.substring(0, 15) + "..."
            : selected
          :
          <div className={`flex gap-[8px] font-medium text-base lg:text-sm ${searchError?'text-[#EB0728]':''} `}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20"
              width="20"
              viewBox="0 -960 960 960"
              className={`size-[20px] ${searchError ? "text-[#EB0728]" : "text-[#707070]"}`}
              fill="currentColor"
            >
              <path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z" />
            </svg>
            {placeholder ? placeholder : "Category"}
          </div>}
        {device === "small" ?
          <svg
            width="13"
            height="9"
            viewBox="0 0 13 9"
            xmlns="http://www.w3.org/2000/svg"
            className={`${searchError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"}`}
            fill="currentColor"
          >
            <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
          </svg>
          : null}
      </div>
      <ul
        className={` w-full shadow-input bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-50 text-start ${open ? " h-[30vh]" : "max-h-0"
          } `}
      >
        <div className="flex items-center px-2 sticky top-0 bg-white">
          <AiOutlineSearch size={18} className="text-ravinput" />
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
            placeholder={placeholder ? placeholder : "Enter category name"}
            className="placeholder:text-ravinput text-ravdeepblue p-2 text-base lg:text-sm  outline-none"
          />
        </div>
        {categoryData
          ?.sort((a, b) => a?.category_name?.localeCompare(b?.category_name)) // Sort categories alphabetically
          ?.map((category) => (
            <li
              key={category?.category_name}
              className={`p-2 text-base lg:text-sm hover:bg-sky-600 hover:text-white
            ${category?.category_name?.toLowerCase() === selected?.toLowerCase() &&
                "bg-sky-600 text-white"
                }
            ${category?.category_name?.toLowerCase().startsWith(inputValue)
                  ? "block"
                  : "hidden"
                }`}
              onClick={() => {
                if (category?.category_name?.toLowerCase() !== selected.toLowerCase()) {
                  setSelected(category?.category_name);
                  handleCategorySelect(category?.category_name)
                  setOpen(false);
                  setInputValue("");
                }
              }}
            >
              {category?.category_name}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default CategorySelector;